import PropTypes from "prop-types";
import React, { Fragment } from 'react';
import { toast } from "react-toastify";
import SmoothScrollbar from "smooth-scrollbar";
import CoreComponent from "../../../../../../framework/component/CoreComponent";
import CoreContainer from "../../../../../../framework/container/CoreContainer";
import ComponentFactory from "../../../../../../framework/factory/ComponentFactory";
import ContainerFactory from "../../../../../../framework/factory/ContainerFactory";

import ShippingAction from "../../../action/order/ShippingAction";

import CurrencyHelper from "../../../../../../helper/CurrencyHelper";
import OrderHelper from "../../../../../../helper/OrderHelper";
import OrderItemService from "../../../../../../service/sales/order/OrderItemService";

import OrderCreateShipmentService from "../../../../service/sales/order/OrderCreateShipmentService";
import ShipmentFactoryService from "../../../../service/sales/order/ShipmentFactoryService";
import CreateShipmentItemSeparatelyShipBundle from "./create-shipment/CreateShipmentItemSeparatelyShipBundle";
import CreateShipmentItemSimpleComponent from "./create-shipment/CreateShipmentItemSimple";
import ShipmentCancellation from "./create-shipment/popup/ShipmentCancellation";
import ShipmentConfirmation from "./create-shipment/popup/ShipmentConfirmation";

class OrderCreateShipmentComponent extends CoreComponent {
    static className = 'OrderCreateShipmentComponent';

    /**
     *  UI setup
     *
     * @param element
     */
    setBlockContentElement = element => {
        if (this.scrollbar) {
            SmoothScrollbar.destroy(this.scrollbar);
        }
        if (element) {
            this.blockContentElement = element;
            this.scrollbar = SmoothScrollbar.init(this.blockContentElement);
        }
    };

    /**
     *
     * @param props
     */
   constructor(props) {
    super(props);
    let decimalSymbol = CurrencyHelper.getCurrencyFormat(props.order).decimal_symbol;
    this.updateShipmentStatus = this.updateShipmentStatus.bind(this);

    // Correção do optional chaining
    const orderId = props.order && props.order.increment_id ? props.order.increment_id : null;

    this.state = {
        show_confirm_popup: false,
        show_cancel_popup: false,
        shipment_items_param: this.prepareShipmentParams(props.order),
        is_max_qty: false,
        decimalSymbol: (decimalSymbol ? decimalSymbol : "."),
        loading: true,
        currentOrderId: orderId
    };
}

    /**
     * Atualiza o contador de participantes concluídos
     */
    calculateCompletionCount() {
        const { order } = this.props;
        const { shipment_items_param } = this.state;
        if (!order || !order.items || !shipment_items_param) return { completed: 0, total: 0 };

        // 1. Identificar todos os itens pais (sem parent_item_id)
        const parentItems = order.items.filter(item => !item.parent_item_id);
        const totalParents = parentItems.length;

        // 2. Contar quantos pais estão completos (todos os itens associados com qty_left = 0)
        let completedParents = 0;

        parentItems.forEach(parentItem => {
            // Encontrar todos os itens associados a este pai (incluindo o próprio pai)
            const allItemsForParent = order.items.filter(item =>
                item.item_id === parentItem.item_id || item.parent_item_id === parentItem.item_id
            );

            // Verificar se todos os itens deste pai estão concluídos
            const allCompleted = allItemsForParent.every(item => {
                // Encontrar o shipmentItem correspondente
                const shipmentItem = Object.values(shipment_items_param).find(
                    si => si.order_item.item_id === item.item_id
                );
                // Se encontrou, verifica o qty_left, senão assume que não está concluído
                return shipmentItem ? shipmentItem.qty_left === 0 : false;
            });

            if (allCompleted) {
                completedParents++;
            }
        });

        return {
            completed: completedParents,
            total: totalParents
        };
    }

    updateShipmentStatus() {
        const { order } = this.props;
        if (!order || !order.items) return;

        // Verifica se todos os itens foram retirados
        const allItemsShipped = order.items.every(item => item.qty === 0);

        // Verifica se pelo menos um item foi retirado, mas nem todos
        const isPartialShipment = order.items.some(item => item.qty > 0) && !allItemsShipped;

        // Atualiza o estado
        this.setState({
            canShip: !allItemsShipped,
            isPartialShipment,
        });
    }

componentDidMount() {
    if (this.props.order) {
        const shipment_items_param = this.prepareShipmentParams(this.props.order);

        // Correção do optional chaining
        const orderId = this.props.order && this.props.order.increment_id;

        this.setState({
            shipment_items_param,
            loading: false,
            currentOrderId: orderId
        });
        this.updateShipmentStatus();
    }
}
    /**
     *  update shipment data
     *
     * @param nextProps
     */
componentDidUpdate(prevProps) {
    // Correção do optional chaining
    const currentOrderId = this.props.order && this.props.order.increment_id;
    const prevOrderId = prevProps.order && prevProps.order.increment_id;

    // Se o pedido mudou
  if (currentOrderId && currentOrderId !== prevOrderId) {
    this.setState({ loading: true }, () => {
        setTimeout(() => {
            const shipment_items_param = this.prepareShipmentParams(this.props.order);

            this.setState({
                shipment_items_param,
                loading: false,
                currentOrderId
            });

            this.updateShipmentStatus();
        }, 1000); // 100ms já costuma ser suficiente
    });
}

}

    /**
     *  trigger whenever click SHIP button
     */
    onClickShip() {
        let shipmentItems = this.getShipmentItems();
        if (!shipmentItems) {
            return toast.error(
                this.props.t('Please select an item to create shipment'),
                {
                    className: 'wrapper-messages messages-warning',
                    autoClose: 2000
                }
            );
        }
        this.showConfirmPopup();
    }

    /**
     *  always show after click SHIP button
     */
    showConfirmPopup() {
        this.setState({
            show_confirm_popup: true
        });
    }

    /**
     *
     * @param {string} note
     * @returns {boolean}
     */
    onConfirmPopupClickOk(note) {
        let shipmentItems = this.getShipmentItems();
        this.createShipment(shipmentItems, note);
    }

    /**
     *  callback after click YES/ NO button on confirm popup
     */
    onConfirmPopupClose() {
        this.setState({
            show_confirm_popup: !this.state.show_confirm_popup
        });
    }

    /**
     *  trigger whenever click CANCEL shipment button
     */
    cancel() {
        this.setState({
            show_cancel_popup: !this.state.show_cancel_popup
        });
    }

    /**
     *  trigger whenever click ship all item toggle button
     */
    useMaxQty() {
        let shipment_items_param = this.state.shipment_items_param;
        Object.keys(shipment_items_param).forEach(orderItemId => {
            let shipmentItem = shipment_items_param[orderItemId];
            let qty = this.state.is_max_qty ? 0 : shipmentItem.qty_left;


            if (shipmentItem.hasOwnProperty('max_qty') && qty > shipmentItem.max_qty) {
                qty = shipmentItem.max_qty;
                let error_message = this.props.t(`The maximum quantity to ship is {{qty}}`, {qty: shipmentItem.max_qty});
                return Object.assign(shipment_items_param[orderItemId], {qty, error_message});
            }

            if (shipmentItem.disable) {
                qty = 0;
                let error_message = this.props.t("The item is not assigned to this Source");
                return Object.assign(shipment_items_param[orderItemId], {qty, error_message});
            }

            Object.assign(shipment_items_param[orderItemId], {qty});
        });
        this.setState({shipment_items_param, is_max_qty: !this.state.is_max_qty});
    }

    /**
     *
     * @returns {boolean|Object}
     */
    getShipmentItems() {
        let shipment_items_param = this.state.shipment_items_param;
        let validateShipment = false;
        let shipmentItems = {};
        let totalQtyToShip = 0;


        Object.keys(shipment_items_param).forEach(orderItemId => {
            let shipmentItem = shipment_items_param[orderItemId];
            if (shipmentItem.qty > 0) {
                validateShipment = true;
            }
            totalQtyToShip += shipmentItem.qty;
            shipmentItems[orderItemId] = shipmentItem.qty;
        });

        if (!validateShipment || totalQtyToShip <= 0 || !Object.keys(shipmentItems).length) {
            return false;
        }


        return shipmentItems;
    }


    /**
     *
     * @param item
     * @param order
     * @returns {{order_item_id: *, order_item: *, qty: number, is_qty_decimal: (number|boolean), qty_left: (*|number)}}
     */
    prepareShipmentItemParamSkipCheckDummy(item, order) {
        let qtyLeft = OrderItemService.getSimpleQtyToShip(item);
        qtyLeft = ShipmentFactoryService.castQty(item, qtyLeft);
        let orderItemId = item.tmp_item_id || item.item_id;
        return {
            order_item_id: orderItemId,
            order_item: item,
            qty_left: qtyLeft,
            qty: 0,
            is_qty_decimal: item.is_qty_decimal
        }
    }

    /**
     *
     * @param item
     * @param order
     * @return {*}
     */
    prepareShipmentItemParam(item, order) {

        let {productQtys} = this.props;
        let {product_id} = item;
        let result = OrderCreateShipmentService.prepareShipmentItemParam(item, order);

        if (!productQtys.hasOwnProperty(product_id)) {
            return result;
        }

        if (productQtys[product_id].isNotExisted) {
            result['disable'] = true;
            return result;
        }

        if (
            productQtys[product_id].hasOwnProperty('isManageStock')
            && !productQtys[product_id].isManageStock
        ) {
            return result;
        }

        let productQty = productQtys[product_id].qty;

        if (productQty === false) {
            return result;
        }

        if (productQty >= result.qty_left) {
            return result;
        }

        result['max_qty'] = Math.max(productQtys[product_id].stockInLocation, 0);

        return result;
    }

    /**
     *
     * @param order
     * @return {Object}
     */
    prepareShipmentParams(order) {
        let shipment_items_param = {};
        if (order && Array.isArray(order.items)) {
            order.items.forEach(item => {
                if (!item.is_virtual &&
                    (!OrderItemService.getParentItem(item, order) || OrderItemService.isShipSeparately(item, order))
                ) {
                    let shipmentItemParam = this.prepareShipmentItemParam(item, order);
                    shipment_items_param[shipmentItemParam.order_item_id] = shipmentItemParam;
                }
            });
        }
        return shipment_items_param;
    }

    /**
     *
     * @param item
     * @return {*}
     */
    getBundleProductOptions(item) {
        if (item.order_item.product_type !== 'bundle') {
            return false;
        }

        let productOptions = item.order_item.product_options;

        if (!productOptions) {
            return false;
        }

        if (typeof productOptions === 'string') {
            productOptions = JSON.parse(productOptions);
        }

        return productOptions;
    }

    /**
     *
     * @param orderItemId
     * @param params
     * @return {*}
     */
    updateShipmentItemParamByOrderItemId(orderItemId, params = {}) {
        let shipment_items_param = this.state.shipment_items_param;
        if (!orderItemId || !shipment_items_param.hasOwnProperty(orderItemId)) {
            return false;
        }
        let shipmentItem = shipment_items_param[orderItemId];
        return this.updateShipmentItemParam(shipmentItem, params);
    }

    /**
     *
     * @param shipmentItem
     * @param params
     */
    updateShipmentItemParam(shipmentItem, params = {}) {
        let orderItemId = shipmentItem.order_item_id;
        let shipment_items_param = this.state.shipment_items_param;
        if (orderItemId && shipment_items_param[orderItemId]) {
            if (params.qty !== undefined) {
                let error_message = "";
                if (shipmentItem.hasOwnProperty('max_qty') && params.qty > shipmentItem.max_qty) {
                    error_message = this.props.t(`The maximum quantity to ship is {{qty}}`, {qty: shipmentItem.max_qty});
                    params.qty = shipmentItem.max_qty;
                }
                if (params.qty > shipmentItem.qty_left) {
                    error_message = this.props.t("Qty to Ship cannot be greater than Qty Left.");
                    params.qty = shipmentItem.qty_left;
                }
                if (params.qty < 0) {
                    error_message = this.props.t("Qty to Ship cannot be smaller than 0.");
                    params.qty = 0;
                }
                if (shipmentItem.disable) {
                    error_message = this.props.t("The item is not assigned to this Source");
                    params.qty = 0;
                }
                params.error_message = error_message;
            }
            Object.assign(shipment_items_param[orderItemId], params);
        }
        this.setState({shipment_items_param})
    }

    /**
     *
     * @param shipmentItems
     * @param note
     */
    createShipment(shipmentItems, note) {
        let order = this.props.order;
        this.props.actions.createShipment(order, shipmentItems, note);
        this.props.cancelCreateShipment();

    }
    /**
     *
     * @param itemId
     * @return {*}
     */
    getItemComponent(itemId) {
        let shipment_items_param = this.state.shipment_items_param;
        if (shipment_items_param[itemId]) {
            let shipmentItem = shipment_items_param[itemId];

            // Verifica se há um associatedCustomer e se o item deve ser filtrado
            if (this.props.associatedCustomer && shipmentItem.order_item.item_id !== this.props.associatedCustomer) {
                return null; // Não renderiza se não for o item correto
            }

            let props = {
                key: itemId,
                order: this.props.order,
                shipmentItem: shipmentItem,
                updateShipmentItemParam: this.updateShipmentItemParam.bind(this),
                decimalSymbol: this.state.decimalSymbol,
                associatedCustomer: this.props.associatedCustomer,
            };

            //console.log("Associated Customer in Parent:", this.props.associatedCustomer);


            // Verifica se o item é um bundle
            let bundleProductOptions = this.getBundleProductOptions(shipmentItem);

            if (!bundleProductOptions) {
                return this.createShipmentItemSimpleComponent(props);
            }

            // Filtra os itens filhos associados ao bundle
            let childrenItems = Object.values(shipment_items_param)
                .filter(item => shipmentItem.order_item.item_id === item.order_item.parent_item_id);

            //console.log(childrenItems, 'CHILDRENITEMSFROMCREATE');

            // Renderiza o componente CreateShipmentItemSeparatelyShipBundle
            return <CreateShipmentItemSeparatelyShipBundle
                {...props} childrenItems={childrenItems} bundleProductOptions={bundleProductOptions} />;
        }
        return null;
    }

    /**
     *
     * @param props
     * @returns {*}
     */
    createShipmentItemSimpleComponent(props) {
        if (props.shipmentItem.qty_left <= 0) {
            return null;
        }

        return <CreateShipmentItemSimpleComponent {...props}/>;
    }
     handleShipAll = () => {
    this.props.childrenItems.forEach((child) => {
      if (this.canIncreaseQty(child)) {
        this.increaseQty(child);
      }
    });
  };

simulateClickOnShipButton() {
   setTimeout(() => {
        // Seleciona o botão pela classe e simula o clique
        const button = document.querySelector(
          ".actions-accept .btn.btn-default"
        );
        if (button) button.click();
      }, 50);
}

    /**
     *
     * @return {*}
     */
   headerContent() {
    const {t} = this.props;
    // const { shipment_items_param } = this.state;

    // Calcula o contador de itens pais completos
    const { completed, total } = this.calculateCompletionCount();
    //console.log({ completed, total }, 'COMPLETION COUNT');

    return (
        <Fragment>
            <div className="block-title">
                <button className="btn-cannel" onClick={() => this.cancel()}>{t('Back')}</button>
                <strong className="title">
                    {t(
                        '{{id}}',
                        {id: this.props.order ? this.props.order.increment_id : ""}
                    )}
                </strong>
                <div className={"price"}>
                    {OrderHelper.formatPrice(
                        this.props.order ? this.props.order.grand_total : 0
                    )}

                </div>

            </div>
            <div className="block-order">
                 <div className="block-order-n">

                <div className="title justify-between">
                    <div>
                        <strong>Nº do pedido:</strong>
                        <span> {t(
                            '{{id}}',
                            {id: this.props.order ? this.props.order.increment_id : ""}
                        )}</span>
                    </div>
                    <div>
                        {total > 0 && (
                        <div className="completed-counter">
                            <span className="label">{t('Concluídos')}:</span> <span className="completed-value">{completed}</span> / <span className="total-value">{total}</span>
                        </div>
                        )}
                        <button className="btn-close" onClick={() => this.props.actions.setIsCreatingShipment(false)}>
                            &times;
                        </button>
                    </div>
                </div>

            </div>
<div className="block-title-ship">
  <button
    className="ship-all-button"
    onClick={(event) => {
      this.useMaxQty(event);
      this.simulateClickOnShipButton();
    }}
  >
    {t("Baixa geral")}
  </button>
</div>


                </div>
        </Fragment>
    );
}

    /**
     *
     * @return {*}
     */
    footerContent() {
        const {t} = this.props;
        return (
            <div className="block-bottom">
                <div className="actions-accept">
                    <button className={"btn btn-default"}
                            type="button"
                            onClick={() => this.onClickShip()}>
                        {t('Take Shipment')}
                    </button>
                </div>
            </div>
        );
    }

    /**
     * template to render
     * @returns {*}
     */
    template() {
        const { t } = this.props;
        const { order } = this.props;
        const { loading }  = this.state;

         const isLoading = loading || !order || !order.items ;


        // Cria o objeto com os dados do cliente
       const customerData = {
    fullName: order
        ? `${order.customer_firstname} ${order.customer_lastname}`
        : "",
    telephone: order && order.addresses && order.addresses.length > 0
        ? order.addresses[0].telephone
        : ""
};
      if (isLoading) {
        return (
            <div className="loading-overlay">
                <div className="loading-spinner">
                    <div className="spinner-circle"></div>
                    <div className="spinner-text">Carregando pedido...</div>
                </div>
            </div>
        );
    }
        return (
            <Fragment>
                <div className="wrapper-shipment-order new-wrapper">
                    {this.headerContent()}
                    <div className="block-content" ref={this.setBlockContentElement}>
                        <div className="table table-order">
                            <div>
                                <tr>
                                    <th className="t-col">&nbsp;</th>
                                    <th className="t-product">{t('Product')}</th>
                                    <th className="t-qty">{t('Qty Left')}</th>
                                    <th className="t-qtyrefund">{t('Qty to Ship')}</th>
                                </tr>
                            </div>
                                {
                                    Object.keys(this.state.shipment_items_param).map(itemId =>
                                        this.getItemComponent(itemId)
                                    )
                                }
                        </div>
                    </div>
                    <div className="order-items">
                    {this.footerContent()}
                    </div>
                </div>
                <ShipmentConfirmation
                    isOpen={this.state.show_confirm_popup}
                    onClose={() => this.onConfirmPopupClose()}
                    onClickOk={(note) => this.onConfirmPopupClickOk(note)}
                    customerData={customerData} // Passa o objeto com os dados do cliente
                />
                <ShipmentCancellation
                    isOpen={this.state.show_cancel_popup}
                    onClose={() => this.cancel()}
                    onClickOk={() => this.props.cancelCreateShipment()}
                />
            </Fragment>
        );
    }
    }

OrderCreateShipmentComponent.propTypes = {
    actions: PropTypes.object.isRequired,
    cancelCreateShipment: PropTypes.func.isRequired,
};

class OrderCreateShipmentContainer extends CoreContainer {
    static className = 'OrderCreateShipmentContainer';

    /**
     *
     * @param state
     * @return {{productQtys: Function.productQtys}}
     */
    static mapState(state) {
        const { productQtys, associatedCustomer } = state.extension.orderCreateShipmentReducer;
        return {
            productQtys,
            associatedCustomer
        };
    }


    static mapDispatch(dispatch) {
        return {
            actions: {
                createShipment: (order, itemsToShip, note, tracks) => dispatch(
                    ShippingAction.createShipment(order, itemsToShip, note, tracks)
                ),
                setIsCreatingShipment: (isCreatingShipment) => dispatch(
                    ShippingAction.setIsCreatingShipment(isCreatingShipment)
                ),
            }
        }
    }
}

/**
 * @type {OrderCreateShipmentContainer}
 */
export default ContainerFactory.get(OrderCreateShipmentContainer).withRouter(
    ComponentFactory.get(OrderCreateShipmentComponent)
)


// WEBPACK FOOTER //
// ./src/extension/take-shipment/view/component/order/order-detail/OrderCreateShipment.js